const BASE_PATH = import.meta.env.BASE_URL || '/'
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

const API_URL = import.meta.env.PROD
  ? `${API_BASE_URL || `${window.location.origin}${BASE_PATH}api`}`
      .replace(/\/+/g, '/')
      .replace(':/', '://')
  : '/api'

const BASE_URL = import.meta.env.PROD
  ? `${window.location.origin}${BASE_PATH}`.replace(/\/+/g, '/').replace(':/', '://')
  : `${window.location.origin}`

const getWebSocketUrl = (path: string): string => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const normalizedPath = path.replace(/^\/+/, '')

  if (import.meta.env.PROD) {
    return `${protocol}//${window.location.host}${BASE_PATH}${normalizedPath}`
      .replace(/\/+/g, '/')
      .replace(':/', '://')
  }

  return `ws://${window.location.host}/${normalizedPath}`
}

export { API_URL, BASE_URL, getWebSocketUrl }
